import { RouteType } from 'types/RouteType';

/**
 * Roadmap QC row 4 — "Move Rescheduling page to Scheduling page."
 *
 * Registered 2026-08-24 under Scheduling. Previously this route existed but was
 * NOT registered (qualityControlRoutesList.ts left it commented out in favour
 * of the hub tab), so `routerStore.goTo('Rescheduling Queue')` — which both
 * TodayDashboard.Header:41 and RejectionsQueue.Header:19 already call — resolved
 * to nothing. goTo catches its own "Route not found" (RouterStore.ts:405-411),
 * so those buttons silently did nothing. Registering it fixes them.
 *
 * The data does not move: the body reads and writes the real `panel-rejections`
 * service. Only the placement changes. It stays in views/qualityControl because
 * that is where its components and its service live; the `group` is what puts
 * it in the Scheduling menu.
 */
const reschedulingQueueRoute: RouteType = {
  name: 'Rescheduling Queue',
  path: '/scheduling/rescheduling-queue',
  layout: '/app',
  viewportCard: {
    header: {
      title: 'Rescheduling Queue',
      component: () => import('./ReschedulingQueue.Header'),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import('./ReschedulingQueue.Body'),
    },
  },
  group: 'Scheduling',
  requiresAuth: true,
  requiresPermission: false,
  channels: ['quality-control'],
};

export default reschedulingQueueRoute;
